import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { BorderRadius } from '../../enums/borderRadius'
import { Color } from '../../enums/color'
import { Spacing } from '../../enums/spacing'
import { getDefaultTransition } from '../../utils/getDefaultTransition'
import { pxToNumber } from '../../utils/pxToNumber'
import { rwd } from '../../utils/rwd'
import { zIndex } from '../../utils/zIndex'
import { Size } from './types/size'
import { getFullScreenSizeModalStyles } from './utils/getFullScreenSizeModalStyles'
import { getXlSizeModalStyles } from './utils/getXlSizeModalStyles'
import { sizeToWidth } from './utils/sizeToWidth'

interface ModalWrapperProps {
  size: Size
  withOverlay: boolean
}

export const ModalWrapper = styled.div<ModalWrapperProps>`
  display: flex;
  align-items: ${({ size }) => (size === 'fullScreen' ? 'stretch' : 'center')};
  justify-content: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${zIndex.Modal};
  background-color: ${({ withOverlay }) =>
    withOverlay ? transparentize(0.52, Color.Grey950) : transparentize(1, Color.Grey950)};
  ${getDefaultTransition('background-color')};
  transition-timing-function: linear;
`

interface ModalProps {
  size: Size
  visible: boolean
}

export const Modal = styled.div<ModalProps>`
  display: flex;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  flex-direction: column;
  width: ${({ size }) => sizeToWidth[size]};
  max-height: 90vh;
  margin: ${Spacing.S32};
  border-radius: ${BorderRadius.R16};
  z-index: 1;
  transform: ${({ visible }) => (visible ? 'scale(1) translateY(0)' : 'scale(0.98) translateY(20px)')};
  background-color: ${Color.White};
  box-shadow: 0 10px 70px ${transparentize(0.8, Color.Black)};
  ${getDefaultTransition('opacity', 'transform')};
  ${({ size }) => size === 'xl' && getXlSizeModalStyles()};
  ${({ size }) =>
    size === 'fullScreen'
      ? getFullScreenSizeModalStyles()
      : css`
          ${rwd.equalOrLessThan('phone')} {
            width: calc(100% - ${2 * pxToNumber(Spacing.S8)}px);
            min-height: -webkit-fill-available;
            max-height: calc(100% - ${2 * pxToNumber(Spacing.S8)}px);
          }
        `}
`
